import { mergeStyles } from "@fluentui/react";

export const commonConfigurationListContainerStyles = mergeStyles([{
    width: '100%',
    minHeight: '100%',
}]);

export const commonConfigurationListUserContainerStyles = mergeStyles([{
    marginBottom: '1dvh',
    width: '100%',
    height: '5dvh',
    backgroundColor: '#F0F0F0'
}]);

export const commonConfigurationAppListContainerStyles = mergeStyles([{
    width: '100%',
    paddingRight: '1dvh',
    minHeight: '100%',
    overflowY: 'auto'
}]);

export const commonConfigurationListTotalContainerStyles = mergeStyles([{
    marginTop: '1dvh',
    width: '100%',
    height: '5dvh',
    backgroundColor: '#F0F0F0'
}]);

//#region GROUPS

export const commonConfigurationListGroupContainerStyles = mergeStyles([{
    marginBottom: '1dvh',
    width: '100%',
    height: '5dvh',
    backgroundColor: '#7e7d7d',
    borderRadius: '10px'
}]);

export const commonConfigurationListGroupInnerContainerStyles = mergeStyles([{
    gap: '1dvh',
    padding: '1dvh',
    backgroundColor: '#7e7d7d',
    borderRadius: '5px'
}]);

export const commonConfigurationListGroupStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1.2rem',
    fontWeight: 600,
    color: 'white',
    textAlign: 'left'
}]);

export const xxlCommonConfigurationListGroupStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1.1rem, 2.5vw, 1.2rem)',
    fontWeight: 600,
    color: 'white',
    textAlign: 'left'
}]);

export const xlCommonConfigurationListGroupStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
    fontWeight: 600,
    color: 'white',
    textAlign: 'left'
}]);

export const lgCommonConfigurationListGroupStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
    fontWeight: 600,
    color: 'white',
    textAlign: 'left'
}]);

export const mdCommonConfigurationListGroupStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.85rem, 2.5vw, 0.9rem)',
    fontWeight: 600,
    color: 'white',
    textAlign: 'left'
}]);

export const smCommonConfigurationListGroupStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.8rem, 2.5vw, 0.85rem)',
    fontWeight: 600,
    color: 'white',
    textAlign: 'left'
}]);

//#endregion GROUPS